import './App.css';
import React, {useEffect, useState} from 'react'
import { CSVLink } from 'react-csv';
import { collection, doc, getDocs} from "firebase/firestore"; 
import { db } from "./firebase-config";

function App() {

  const [subscription, setSubscription] = useState([])
  const [subscriptionData, setSubscriptionData] = useState([])


  // RECUPERER LES DONNEES DEPUIS LA BASE 

  const loadSub = async () => {
  setSubscription([])
    const ref = collection(db, 'timsSub');
    const querySnapshot2023 = await getDocs(ref)
      querySnapshot2023.forEach((doc) => {     
          setSubscription(subscription => [doc.data(), ...subscription])
        }) 
   
  }


  
  // FORMATER LE TABLEAUX 

  const formatData = async () => {
      setSubscriptionData([])
      if(subscription.length > 0) {
        subscription.map(sub => {
          setSubscriptionData(subscriptionData =>[{
              nom: sub.NOM, 
              prenom: sub.PRENOM, 
              organisme: sub.ORGANISME, 
              fonction: sub.FONCTION, 
              mail: sub.MAIL, 
              autorisation: sub.AUTORISATION,  
          }, ...subscriptionData])
      })
      }
  }

  const subscriptionHeaders = [
    {label: "Organisme ou entreprise ?", key: "organisme"},
    {label: "Nom", key: "nom"},
    {label: "Prénom", key: "prenom"},
    {label: "Fonction", key: "fonction"},
    {label: "Mail", key: "mail"},
    {label: "Autorisez-vous la collecte de vos données par les partenaires de la MIFE ?", key: "autorisation"},
]

  useEffect(() => {
    loadSub()
    formatData()
  }, [])

  
  useEffect(() => {
    formatData()
  }, [subscription])


  console.log(subscription);
  console.log(subscriptionData);


  return (
    <div className="App">
      {subscriptionData.length > 0 &&
       <div className="file" title={`Télécharger`}>
          <CSVLink data={subscriptionData} separator={";"} headers={subscriptionHeaders}  filename={"inscriptions_tims.csv"} target="_blank">Télécharger</CSVLink>      
       </div>
      }

    </div>
  );
}

export default App;
